import { Component, HostBinding, OnInit, HostListener, ElementRef } from '@angular/core';
import { Element, ElementsService } from 'dbweb-core';
import { IndexService, CardSize, CardType } from '../index.service';
import { FormControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { truncate } from 'fs';

@Component({
	selector: 'common-navigation',
	templateUrl: './navigation.component.html',
	styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
	@HostBinding('class.c-index-navigation') hostClass = true;

	filterElements: Observable<Element[]>;
	formControl = new FormControl();
	validElement = false;
	allEles: Element[];
	displayElements: Element[] = [];
	readonly MaxElementNumber = 8;
	handleNav = false;
	navSize: CardSize;
	navName = 'navigation';

	constructor(
		public svr: IndexService,
		public eles: ElementsService,
		private router: Router,
		private eRef: ElementRef
	) {
		this.navSize = this.svr.userSetting.Cards.find(x => x.Type === this.navName).Size;
		// console.log(this.navSize);
	}

	ngOnInit() {
		this.allEles = Object.values(this.eles.getEles()).filter(e => !e.NotMenu);
		this.filterElements = this.formControl.valueChanges.pipe(
			startWith(''),
			map(v => {
				const arr = this.allEles.filter(e =>
					this.formatElementDisplayLabel(e).toLowerCase().includes(v.toLowerCase())
				);
				return arr.sort((a, b) => a.title().localeCompare(b.title()));
			})
		);
		this.formControl.valueChanges.subscribe(v => {
			this.validElement = !!this.allEles.find(e => this.formatElementDisplayLabel(e) === v);
		});
		this.refreshDisplayElements();
	}
	formatElementDisplayLabel(ele: Element): string {
		return `${ele.title()}(${ele.Name})`;
	}
	refreshDisplayElements() {
		this.displayElements = this.svr.userSetting.NavigationElements
			.filter(v => this.eles.get(v))
			.map(v => this.eles.get(v));
		// console.log('----', this.displayElements);
	}
	change(val: string) {
		console.log(val);
	}
	add() {
		const ele = this.allEles.find(v => this.formatElementDisplayLabel(v) === this.formControl.value);
		// console.log(ele);
		if (!this.svr.userSetting.NavigationElements.includes(ele.Name)) {
			this.svr.userSetting.NavigationElements.push(ele.Name);
			this.svr.updateSetting().subscribe(() => {
				this.refreshDisplayElements();
			});
		}
	}
	execute() {
		const ele = this.allEles.find(v => this.formatElementDisplayLabel(v) === this.formControl.value);

		this.router.navigateByUrl(this.eles.frontElementURL(ele.Name, decodeURI(ele.URL)));
	}
	routerLink(ele: Element) {
		return this.eles.frontElementURL(ele.Name, decodeURI(ele.URL));
	}

	// â æµ®çªå é¤éæ©æºåç´ 
	removeEle(i: number) {
		this.svr.userSetting.NavigationElements.splice(i, 1);
		this.svr.updateSetting().subscribe(() => {
			this.refreshDisplayElements();
		});
	}

	removeCard(cardName: string) {
		const arr = this.svr.userSetting.Cards;
		this.svr.userSetting.Cards = arr.filter((item: any) => item.Type !== cardName);
	}
	hasEles() {
		const ele = this.allEles.find(v => this.formatElementDisplayLabel(v) === this.formControl.value);
		return this.svr.userSetting.NavigationElements.includes(ele.Name);
	}

	changeSize(sz: CardSize) {
		this.navSize = sz;
		this.svr.userSetting.Cards.find(x => x.Type === 'navigation').Size = this.navSize;
		this.svr.updateSetting().subscribe(() => {
			console.log(this.svr.userSetting.Cards);
		});
	}
}
